import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { JobProfile } from 'src/app/core/models/jobProfile';
import { RunCandidateScore } from 'src/app/core/models/runCandidateScore';
import { ConvertDurationInYearsPipe } from 'src/app/core/pipes/convert-duration-in-years.pipe';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { JobService } from 'src/app/core/services/job.service';
import { ManageSkillsService } from 'src/app/core/services/manage-skills.service';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { ResumeService } from 'src/app/core/services/resume.service';
import { UserRoleService } from 'src/app/core/services/user-role.service';

@Component({
  selector: 'app-job-profile',
  templateUrl: './job-profile.component.html',
  styleUrls: ['./job-profile.component.css']
})
export class JobProfileComponent implements OnInit {


  @Input() jobId;
  @Input() context;
  @Output() updateLocationCallback = new EventEmitter<any>();
  @Output() showJobProfileCallback = new EventEmitter<any>();
  @Output() closeModalCallback = new EventEmitter<any>();

  job: any;
  companyId: any;
  userId: any;
  requisitionUrl: SafeUrl;
  jobReportPdfUrl: SafeUrl;
  jobDownloadPdfUrl: SafeUrl;
  jobReportPdfViewUrl: SafeUrl;
  requisitionUrlUpload: SafeUrl;
  jobReportPdfUrlUpload: SafeUrl;
  jobDownloadPdfUrlUpload: SafeUrl;
  jobReportPdfViewUrlUpload: SafeUrl;
  requisitionUrlCreate: SafeUrl;
  jobReportPdfUrlCreate: SafeUrl
  jobDownloadPdfUrlCreate: SafeUrl;
  jobReportPdfViewUrlCreate: SafeUrl;
  jobCopy: any;
  allExistingSkills: any = [];
  allExistingDegrees: any = [];
  allExistingRoles: any = [];
  allExistingFieldOfStudy: any = [];
  allExistingCertificates: any = [];
  allExistingJDActionWords: any = [];
  timePeriods: any = [];
  skillsTimePeriods: any = [];
  allUpdatedJDActionWords: any = [];
  sponsorshipList: any = [];

  loadingFlag: boolean = true;
  isEdit: boolean = false;
  isSkillsEditSaved: boolean = false;
  showEdit: boolean = false;
  isSuperUserOr4dot5Admin: boolean;
  scoringInProgress: boolean = false;
  isSkillsChanged: boolean = false;

  constructor(
    @Inject('$rootScope') public $rootScope:any,
    @Inject('requisitionService') public requisitionService:any,
    private userRoleService: UserRoleService,
    private jobService: JobService,
    private companyService: CompanyService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private modalService: AngularModalService,
    private resumeService: ResumeService,
    private sanitizer: DomSanitizer,
    private manageSkillsService: ManageSkillsService,
    private authService: AuthService,
    private convertDurationInYearsPipe: ConvertDurationInYearsPipe,
    @Inject('$state') public $state:any,
  ) { }

  ngOnInit() {
    //variables
    this.requisitionUrl = '';
    this.companyId = this.authService.getUserDetails().company.companyId;
    this.userId = this.authService.getUserDetails().id;

    this.isSuperUserOr4dot5Admin = this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin();
    this.job = new JobProfile();
    this.requisitionUrl = this.sanitizeUrl(this.requisitionService.getRequisitionDocumentUrl(this.jobId));
    this.jobReportPdfUrl = this.sanitizeUrl(this.jobService.getJobReportPdfUrl(this.jobId));
    this.jobDownloadPdfUrl = this.sanitizeUrl(this.jobService.getJobDownloadPdfUrl(this.jobId));
    this.jobReportPdfViewUrl = this.sanitizeUrl(this.jobReportPdfUrl + '#view=fitH');

    this.jobReportPdfUrlUpload = this.sanitizeUrl(this.jobService.getJobReportPdfUrlUpload(this.jobId, 'upload'));
    this.jobDownloadPdfUrlUpload = this.sanitizeUrl(this.jobService.getJobDownloadPdfUrlUpload(this.jobId, 'upload'));
    this.jobReportPdfViewUrlUpload = this.sanitizeUrl(this.jobReportPdfUrlUpload + '#view=fitH');

    this.jobReportPdfUrlCreate = this.sanitizeUrl(this.jobService.getJobReportPdfUrlUpload(this.jobId, 'create'));
    this.jobDownloadPdfUrlCreate = this.sanitizeUrl(this.jobService.getJobDownloadPdfUrlUpload(this.jobId, 'create'));
    this.jobReportPdfViewUrlCreate = this.sanitizeUrl(this.jobReportPdfUrlCreate + '#view=fitH');
    this.getAllSponsorships();
    if (!(this.companyService.isStaffingCompany() && this.job.sharedRequisition)) {
    this.getAllMasterLists();
    } else {
      this._getJobProfile(() => {
        this.loadingFlag = false;
      });
    }
  }

  sanitizeUrl(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
}

  _getJobProfile(successCallback) {
    this.jobService.getJobProfile(this.jobId, (data) => {
      this.job = data;
      if (!this.job.profileCriteriaInfo) {
        this.job.profileCriteriaInfo = {};
      }
      this.mergeProfileCriteriaData(this.job);
      this._setDeleteFlags();
      this._checkJobPdfFileExists(this.job);
      this.setJobProfileDisplayData();
      this.jobCopy = angular.copy(this.job);
      this.showEdit = !(this.companyService.isStaffingCompany() && this.job.sharedRequisition);
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      // do nothing.
    });
  }

  _setDeleteFlags() {
    if (this.job.educations) {
      this.job.educations.forEach(education => {
        education.isDeleted = false;
      });
    } else {
      this.job.educations = [];
    }

    if (this.job.experiences) {
      this.job.experiences.forEach(experience => {
        experience.isDeleted = false;
      });
    } else {
      this.job.experiences = [];
    }

    if (this.job.profileCriteriaInfo.technicalSkills) {
      this.job.profileCriteriaInfo.technicalSkills.forEach(skill => {
        skill.isDeleted = false;
        skill.displayExperience = this.setExperienceDisplay(skill);
      });
    } else {
      this.job.profileCriteriaInfo.technicalSkills = [];
    }

    if (this.job.profileCriteriaInfo.operationalSkills) {
      this.job.profileCriteriaInfo.operationalSkills.forEach(skill => {
        skill.isDeleted = false;
        skill.displayExperience = this.setExperienceDisplay(skill);
      });
    } else {
      this.job.profileCriteriaInfo.operationalSkills = [];
    }

    if (this.job.profileCriteriaInfo.softSkills) {
      this.job.profileCriteriaInfo.softSkills.forEach(skill => {
        skill.isDeleted = false;
        skill.displayExperience = this.setExperienceDisplay(skill);
      });
    } else {
      this.job.profileCriteriaInfo.softSkills = [];
    }

    if (this.job.profileCriteriaInfo.otherSkills) {
      this.job.profileCriteriaInfo.otherSkills.forEach(skill => {
        skill.isDeleted = false;
        skill.displayExperience = this.setExperienceDisplay(skill);
      });
    } else {
      this.job.profileCriteriaInfo.otherSkills = [];
    }

    if (this.job.certifications) {
      this.job.certifications.forEach(certification => {
        certification.isDeleted = false;
      });
    } else {
      this.job.certifications = [];
    }

    if (this.job.compensations) {
      this.job.compensations.forEach(compensation => {
        compensation.isDeleted = false;
      });
    } else {
      this.job.compensations = [];
    }
  }

  _checkJobPdfFileExists(job) {
    job.isJobFilePdf = false;
    if (job.jobRequisition && job.jobRequisition.fileName) {
      job.isJobFilePdf = (job.jobRequisition.fileName.slice(-4)) === '.pdf' ? true : false;
    }
  }

  undoEdit() {
    if (this._hasDataChanged()) {
      let title = "Alert!";
      let message = "The changes were not saved. The Requisition will be put back to its previous state.<br> Are you sure?";
      this.alertsAndNotificationsService.showConfirm(title, message, "warning", true, () => {
        this.job = angular.copy(this.jobCopy);
        this.isEdit = false;
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      }, () => {
        //do nothing
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      });
    } else {
      this.isEdit = false;
    }
  }

  setProfileCriteriaInfoSkills(profileCriteriaInfo) {
    const categorizeSkills = (skills, skillType) => {
      if (skills && skills.length > 0) {
        return skills
          .filter(skill => skill.displayName && skill.displayName.trim() !== '')
          .map(skill => ({ ...skill, skillType }));
      }
      return [];
    };

    profileCriteriaInfo.technicalSkills = categorizeSkills(profileCriteriaInfo.technicalSkills, 'TECHNICALSKILLS');
    profileCriteriaInfo.operationalSkills = categorizeSkills(profileCriteriaInfo.operationalSkills, 'OPERATIONALSKILLS');
    profileCriteriaInfo.otherSkills = categorizeSkills(profileCriteriaInfo.otherSkills, 'OTHERS');
    profileCriteriaInfo.softSkills = categorizeSkills(profileCriteriaInfo.softSkills, 'SOFTSKILLS');

    ['certifications', 'experiences', 'educations'].forEach(key => {
      profileCriteriaInfo[key] = profileCriteriaInfo[key]
        ? profileCriteriaInfo[key]
          .filter(item => item.displayName && item.displayName.trim() !== '')
          .map(item => ({ ...item }))
        : [];
    });
  }

  saveJobProfile(isReRun, successCallback, errorCallback) {
    let clientOrBUIdStepOne = !this.job.jobRequisition.clientOrBU ? null : this.job.jobRequisition.clientOrBU.id;
    this.job.profileCriteriaInfo.title = this.job.title;
    this.setProfileCriteriaInfoSkills(this.job.profileCriteriaInfo);
    let step1DetailsTempObject:any = {
      jobId: this.jobId,
      title: this.job.title,
      isSharedClientRequisition: this.job.sharedRequisition,
      sharedClientBuOrCorpId: (this.job.jobRequisition.sharedClientBuOrCorpId && this.job.jobRequisition.sharedClientBuOrCorpId != '') ? this.job.jobRequisition.sharedClientBuOrCorpId : null,
      clientOrBUId: clientOrBUIdStepOne,
      requistionNumber: this.job.requisitionNumber,
      isFutureMatchesOnly: this.job.profileCriteriaInfo.futureMatchesOnly,
      profileCriteriaInfo: this.job.profileCriteriaInfo,
      rerunScore: isReRun,
      asyncActionType: 'async',
      source: this.job.jobCurrentState === 'DRAFT' ? 'CREATEREQ' : ['candidateWorkflow', 'candidateJobMatchCard', 'candidateJobComparison'].includes(this.context) ? 'UPDATEREQ': 'EDITREQ',
      tab: this.job.jobCurrentState !== 'DRAFT' ? 'EDIT_REQUISITION' : 'ADD_REQUISITION' 
    };
    step1DetailsTempObject.profileCriteriaInfo.userEnteredDescription = true;
    let updateFlag = true;
    let companyId = (this.job && this.job.jobRequisition && this.job.jobRequisition.company.id) ? this.job.jobRequisition.company.id : this.authService.getUserDetails().company.companyId;
    step1DetailsTempObject.recalculateLater = !isReRun;
    if (this.job.jobCurrentState !== 'DRAFT') {
      step1DetailsTempObject.includeCandidatesWithNoAdditionalDetails = this.job.includeCandidatesWithNoAdditionalDetails;
      step1DetailsTempObject.includeCandidatesMatchingMandatoryCriteria = this.job.includeCandidatesMatchingMandatoryCriteria;
      step1DetailsTempObject.criteriaUpdated = this.isSkillsChanged;
      step1DetailsTempObject.flagsUpdated = this.checkIfFlagsChanged(step1DetailsTempObject);
      this.jobService.createUpdateJobDetails(updateFlag, step1DetailsTempObject, companyId, clientOrBUIdStepOne, this.authService.getUserDetails().id, (data) => {
        if (!step1DetailsTempObject.asyncActionType) {
          this.job.profileCriteriaInfo = (data && data.t) ? { ...data.t.profileCriteriaInfo } : this.job.profileCriteriaInfo;
        }
        if (successCallback) {
          successCallback(data);
        }
      }, (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
      });
    } else {
      updateFlag = false;
      clientOrBUIdStepOne = !this.job.jobRequisition.clientOrBU ? null : this.job.jobRequisition.clientOrBU.id;
      this.jobService.createUpdateJobDetails(updateFlag, step1DetailsTempObject, companyId, clientOrBUIdStepOne, this.authService.getUserDetails().id, (data) => {
        this.job.profileCriteriaInfo = (data && data.t) ? { ...data.t.profileCriteriaInfo } : this.job.profileCriteriaInfo;
        if (successCallback) {
          successCallback(data);
        }
      }, (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
      });
    }
  }

  saveAndReloadJobProfile(isReRun) {
    this.loadingFlag = true;
    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();

    this.saveJobProfile(isReRun, (data) => {
      setTimeout(() => {
        this._getJobProfile(() => {
        this.isSkillsEditSaved = !isReRun;
        this.isEdit = false;
        this.loadingFlag = false;
        this.isSkillsChanged = false;

        const title = !isReRun ? "Job updated successfully." : "Job matching in Progress";
        this.isSkillsEditSaved = false;

        this.alertsAndNotificationsService.showAlertWithCallBack(title, data.message, "success", () => {
          if (isReRun) {
            if (['candidateWorkflow', 'candidateJobMatchCard', 'candidateJobComparison'].includes(this.context)) {
              this.$state.go('missioncontrol.requisitions');
            } else {
              if (this.closeModalCallback) {
                this.closeModalCallback.emit();
              }
            }
          } else {
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
          }
        });
      });
      }, 1000);
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
    });
  }

  save() {
    if (!this._hasDataChanged()) {
      this.alertsAndNotificationsService.showAlertWithCallBack(
        "No changes made",
        "No changes made to save",
        "warning",
        () => this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen()
      );
      return;
    }

    let step1DetailsTempObject: any = {
      includeCandidatesWithNoAdditionalDetails: this.job.includeCandidatesWithNoAdditionalDetails,
      includeCandidatesMatchingMandatoryCriteria: this.job.includeCandidatesMatchingMandatoryCriteria
    };

    let title = (!this.isSkillsChanged && this.checkIfFlagsChanged(step1DetailsTempObject)) ? "Run Match" : "Rerun Score and Match";

    this.alertsAndNotificationsService.showConfirm(
      "Alert!",
      "Do you want to save the changes made to the requisition?",
      "warning",
      true,
      () => this._showRecalculateScoreConfirmation(title, (isReRun) => this.saveAndReloadJobProfile(isReRun)),
      () => this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen()
    );
  }

  removeUnusedSkills(skills) {
    const skillsArray = [
      'educations',
      'experiences',
      'technicalSkills',
      'operationalSkills',
      'softSkills',
      'otherSkills',
      'certifications'
    ];

    skillsArray.forEach((skill) => {
      if (skills[skill]) {
        skills[skill] = skills[skill]
          .filter(item => item.displayName && item.displayName.trim() !== '')
          .map(item => ({
            ...item,
            range: !item.range ? "" : (item.displayName && item.displayName.includes(item.range)) ? item.range : "",
            plusTo: !item.plusTo ? "" : item.plusTo,
          }));
      } else {
        skills[skill] = [];
      }
    });
  }

  setProfileCriteria(obj1, obj2) {
    const newObj = {};
    const keys = Object.keys(obj1);

    keys.forEach(key => {
      const val1 = obj1[key];
      const val2 = obj2[key];

      if (Array.isArray(val1) && Array.isArray(val2)) {
        if (val1.length !== val2.length) {
          newObj[key] = val2;
        } else {
          newObj[key] = val1.map((item, index) => {
            const newItem = {};
            const item2 = val2[index] || {};

            Object.keys(item).forEach(subKey => {
              newItem[subKey] = item2[subKey];
            });

            return newItem;
          });
        }
      } else {
        if (!val1) {
          newObj[key] = val2;
        } else if (!val2) {
          newObj[key] = [];
        } else {
          newObj[key] = val2;
        }
      }
    });

    return newObj;
  }

  _hasDataChanged() {
    let currentStep1DataObject = _.cloneDeep(this.job);
    let step1DetailsTempObject = _.cloneDeep(this.jobCopy);
    this.removeUnusedSkills(currentStep1DataObject.profileCriteriaInfo);
    this.removeUnusedSkills(step1DetailsTempObject.profileCriteriaInfo);
    currentStep1DataObject.profileCriteriaInfo = this.setProfileCriteria(step1DetailsTempObject.profileCriteriaInfo, currentStep1DataObject.profileCriteriaInfo);
    this.isSkillsChanged = !_.isEqual(step1DetailsTempObject.profileCriteriaInfo, currentStep1DataObject.profileCriteriaInfo);
    let dataChanged = !_.isEqual(currentStep1DataObject, step1DetailsTempObject);
    return dataChanged;
  }

  _showRecalculateScoreConfirmation(title, successCallback) {
    let message = (title == 'Run Match') ? "Do you want to run match?" : "Do you want to run score and run match?";
    this.alertsAndNotificationsService.showConfirm(title, message, "info", true, () => {
      this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      if (successCallback) {
        successCallback(true);
      }
    }, () => {
      //do nothing
      this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      if (successCallback) {
        successCallback(false);
      }
    });
  }

  recalculateScore() {
    // this.utilityService.showLoadingModal("Recalculating Score...");
    // api call to recalculate the score;
    let requestObject = new RunCandidateScore(this.companyId, this.userId);
    requestObject.jobId = this.jobId;
    requestObject.rerunType = "REQUISITION";
    this.resumeService.reRunResumeScore(requestObject, (data) => {
      // this.jobService.getJobMatchScores(this.jobId, (data) => {
      this.isSkillsEditSaved = false;
      // this.utilityService.hideLoadingModal();
      this.alertsAndNotificationsService.showAlertWithCallBack("Candidate scoring in Progress", data.message, "success", () => {
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        if (this.closeModalCallback) {
          this.closeModalCallback.emit();
        }
      });
    }, error => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
    })
  }

  getAllSkills(successCallback) {
    let filterObject = {
      searchSkill: '',
      searchByParentSkill: '',
      searchCategory: '',
      sortColumn: 'skill',
      sortDir: 'ASC',
      includeAlternateSkills: false
    };

    this.allExistingSkills = [];
    this.jobService.getAllSkills(filterObject, (data) => {
      this.allExistingSkills = data ? data.allSkills.filter(skill => skill) : [];
      if (successCallback) {
        successCallback();
      }
    }, error => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getDegreesEntities(successCallback) {
    let degreeFilerObj = {
      searchDegree: '',
      sortColumn: '',
      sortDir: ''
    }
    this.allExistingDegrees = [];
    this.manageSkillsService.getAllDegreesEntityLists(degreeFilerObj, (data) => {
      this.allExistingDegrees = data ? data.allEntities : [];
      if (successCallback) {
        successCallback()
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getFieldOfStudyEntities(successCallback) {
    let fieldOfStudyObj = {
      searchFieldOfStudy: '',
      sortColumn: '',
      sortDir: ''
    }


    this.manageSkillsService.getAllFieldOfStudyLists(fieldOfStudyObj, (data) => {
      this.allExistingFieldOfStudy = [];
      this.allExistingFieldOfStudy = data ? data.allEntities : [];
      if (successCallback) {
        successCallback()
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getRoles(successCallback) {
    let roleObj = {
      searchRole: '',
      sortColumn: '',
      sortDir: ''
    }
    this.manageSkillsService.getAllCandidateRolesLists(roleObj, (data) => {
      this.allExistingRoles = [];
      this.allExistingRoles = data ? data.allEntities : [];
      if (successCallback) {
        successCallback()
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getCertificates(successCallback) {
    let certificatesObj = {
      searchName: '',
      sortColumn: '',
      sortDir: ''
    }
    this.manageSkillsService.getAllCertificationsLists(certificatesObj, (data) => {
      this.allExistingCertificates = [];
      this.allExistingCertificates = data ? data.allEntities : [];
      if (successCallback) {
        successCallback()
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getJdActions(successCallback) {
    let jdActionsObj = {
      searchName: '',
      sortColumn: '',
      sortDir: ''
    }
    this.manageSkillsService.getAllJdActionsLists(jdActionsObj, (data) => {
      this.allExistingJDActionWords = [];
      this.allExistingJDActionWords = data ? data.allEntities : [];
      if (successCallback) {
        successCallback()
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  setJDActionsValues(actionWord, key, fallbackKey = "value") {
    return actionWord[key] ? actionWord[key][fallbackKey] : "";
  }

  setJDActionWords() {
    this.allExistingJDActionWords.forEach(jdAction => {
      if (jdAction.jobDescriptionLanguageDropdown && jdAction.jobDescriptionLanguageDropdown.length > 0) {
        jdAction.jobDescriptionLanguageDropdown.forEach(actionWord => {
          let actionWordTemp = { name: actionWord, jdAction: jdAction };
          this.allUpdatedJDActionWords.push(actionWordTemp);
        });
      }
    });

    const prepositions = [" in ", " with ", " of ", " at "];

    this.allUpdatedJDActionWords.forEach(actionWord => {
      prepositions.forEach(preposition => {
        this.skillsTimePeriods.push({
          name: `${actionWord.name}${preposition}`,
          value: {
            minExperienceInMonths: this.setJDActionsValues(actionWord.jdAction, 'minExperienceInMonths'),
            maxExperienceInMonths: this.setJDActionsValues(actionWord.jdAction, 'maxExperienceInMonths'),
            plusTo: this.setJDActionsValues(actionWord.jdAction, "minExperienceInMonths", "sign"),
            months: 0,
            range: "",
            isJDActionWord: true,
            jdAction: actionWord
          }
        });
      });
    });

  }

  setTimePeriodsForTypeAhead() {
    this.timePeriods = this.manageSkillsService.setTimePeriodsInRequisitionSkillsTypeAhead();
    this.skillsTimePeriods = [];
    let timePeriodsWithExperience = [];
    this.timePeriods.forEach(skill => {
      let tempSkill = { ...skill };
      this.skillsTimePeriods.push(tempSkill);

      let experienceInSkill = { ...skill, name: skill.name + 'experience in ' };
      this.skillsTimePeriods.push(experienceInSkill);

      let experienceWithSkill = { ...skill, name: skill.name + 'experience with ' };
      this.skillsTimePeriods.push(experienceWithSkill);

      let experienceOfSkill = { ...skill, name: skill.name + 'experience of ' };
      this.skillsTimePeriods.push(experienceOfSkill);

      let experienceSkill = { ...skill, name: skill.name + 'experience ' }
      timePeriodsWithExperience.push(experienceSkill);
    });

    this.setJDActionWords();
    this.timePeriods = [...this.timePeriods, ...timePeriodsWithExperience];
  }

  getAllMasterLists() {
    this.loadingFlag = true;
    let completedRequests = 0;
    let totalRequests = 7;

    const checkCompletion = () => {
      completedRequests++;
      if (completedRequests === totalRequests) {
        setTimeout(() => {
          this.setTimePeriodsForTypeAhead();
        }, 50);
        setTimeout(() => {
          this.loadingFlag = false;
        }, 100);
      }
    };
    this._getJobProfile(() => checkCompletion());
    this.getAllSkills(() => checkCompletion());
    this.getDegreesEntities(() => checkCompletion());
    this.getFieldOfStudyEntities(() => checkCompletion());
    this.getRoles(() => checkCompletion());
    this.getCertificates(() => checkCompletion());
    this.getJdActions(() => checkCompletion());
  }

  updateLocation() {
    if (this.updateLocationCallback) {
      this.updateLocationCallback.emit();
    }
  }

  showJobProfile() {
    if (this.showJobProfileCallback) {
      this.showJobProfileCallback.emit();
    }
  }

  mergeProfileCriteriaData(job) {
    const skillMapping = {
      technicalSkills: 'technicalSkills',
      operationalSkills: 'operationalSkills',
      softSkills: 'softSkills',
      extraSkills: 'otherSkills' // job.extraSkills <-> profileCriteriaInfo.otherSkills
    };
  
    // Combine all skills from job into one array
    let allJobSkills = [];
    Object.keys(skillMapping).forEach(function(jobKey) {
      let skills = job[jobKey] ? job[jobKey] : [];
      allJobSkills = allJobSkills.concat(skills);
    });
  
    // For each skill category in profileCriteriaInfo, update only status and experience if matched
    Object.values(skillMapping).forEach(function(profileKey) {
      let profileSkills = (job.profileCriteriaInfo && job.profileCriteriaInfo[profileKey]) ? job.profileCriteriaInfo[profileKey] : [];
      let mergedSkills = [];
  
      profileSkills.forEach(function(profileSkill) {
        let match = allJobSkills.find(function(jobSkill) {
          return jobSkill.competency && profileSkill.competency &&
                 jobSkill.competency.toLowerCase() === profileSkill.competency.toLowerCase();
        });
  
        if (match) {
          mergedSkills.push({
            ...profileSkill,
            status: match.status,
            experience: match.experience
          });
        } else {
          mergedSkills.push(profileSkill);
        }
      });
  
      if (job.profileCriteriaInfo) {
        job.profileCriteriaInfo[profileKey] = mergedSkills;
      }
    });
  
  }  
  
  setExperienceDisplay(skill) {
    let displayExperience = '';
    if ((skill.range && (skill.range.toLowerCase() === 'minimum' || skill.range.toLowerCase() === 'atleast')) || skill.plusTo === '+') {
      displayExperience = `${skill.experience}+ ${skill.experience > 1 ? 'years' : 'year'}`;
    } else if (skill.range && skill.range.toLowerCase() === 'maximum') {
      displayExperience = `<= ${skill.experience} ${skill.experience > 1 ? 'years' : 'year'}`;
    } else if (skill.plusTo === 'to' || (skill.actionWord && skill.actionWord != '')) {
      let minYears = Math.round(skill.minExperienceInMonths / 12);
      let maxYears = Math.round(skill.maxExperienceInMonths / 12);
      let label = maxYears > 1 ? 'years' : 'year';
      displayExperience = `${minYears} - ${maxYears} ${label}`;
    } else {
      displayExperience = this.convertDurationInYearsPipe.transform(skill.experience);
    }
    return displayExperience;
  }

  getJobScoringJobStatus() {
        this.jobService.getJobScoringJobStatus(this.jobId, data => {
            this.scoringInProgress = data;
            if(this.scoringInProgress) {
                let message = "Job matching is in progress. You will be notified once it's completed..."
                this.alertsAndNotificationsService.showAlertWithCallBack("Job matching in Progress", message, "success", () => {
                    this.$state.go('missioncontrol.requisitions');
                });
            }
        }, error => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

  getAllSponsorships() {
    this.jobService.getAllSponsorshipTypes((data) => {
      this.sponsorshipList = data;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    })
  }

  setJobProfileDisplayData() {
    this.job.displayjobSalary = null;
    this.job.displaySponsorships = null;
    this.job.displayWorkLocations = null;

    const formatDuration = (duration) => {
        if (!duration) return '';
        return duration
            .toLowerCase()
            .replace('per_', 'Per ')
            .replace(/\b\w/g, char => char.toUpperCase());
    };

    // Salary
    if (this.job.jobSalary) {
      const { minSalary, maxSalary, salaryType, salaryDuration, currency } = this.job.jobSalary;
      const durationFormatted = formatDuration(salaryDuration);

      if (salaryType === 'SPECIFIC') {
        this.job.displayjobSalary = `${maxSalary} ${currency} ${durationFormatted}`;
      } else if (salaryType === 'RANGE') {
        this.job.displayjobSalary = `${minSalary} to ${maxSalary} ${currency} ${durationFormatted}`;
      }
    } else {
      this.job.displayjobSalary = 'Job Salary not available';
    }

    // Work Locations
    this.job.displayWorkLocations = (Array.isArray(this.job.workLocations) && this.job.workLocations.length > 0)
      ? this.job.workLocations.map(loc => loc.name).join(', ')
      : 'Work locations not available';

    // Sponsorships
    this.job.displaySponsorships = (Array.isArray(this.job.sponsorships) && this.job.sponsorships.length)
      ? this.job.sponsorships.map(code => {
        const match = this.sponsorshipList.find(item => item.value === code);
        return match ? match.name : code;
      }).join(', ')
      : 'Sponsorships not available';
  }

  checkIfFlagsChanged(currentStep1TempObject) {
    return (this.jobCopy.includeCandidatesWithNoAdditionalDetails !== currentStep1TempObject.includeCandidatesWithNoAdditionalDetails) ||
      (this.jobCopy.includeCandidatesMatchingMandatoryCriteria !== currentStep1TempObject.includeCandidatesMatchingMandatoryCriteria);
  }
  

}
